<div class="d-flex justify-content-between" *ngIf="name || description">
  <span [ngStyle]="{ 'font-weight': fontWeight }" style="padding-left: 5px" *ngIf="name">{{ name }}</span>
  <span [ngStyle]="{ 'font-weight': fontWeight }" style="padding-left: 5px" *ngIf="description">{{ description }}</span>
</div>
<ag-grid-angular
  id="myGrid"
  [class]="'ag-theme-quartz container-grid common-grids ' + classNames"
  [rowData]="gridRowData"
  [components]="components"
  [columnDefs]="gridColDefs"
  [defaultColDef]="gridDefaultColDef"
  [rowSelection]="rowSelection"
  [getContextMenuItems]="getContextMenuItems"
  [pagination]="hasPagination"
  [paginationPageSize]="gridPaginationPageSize"
  [detailRowAutoHeight]="true"
  [enableRangeSelection]="true"
  [copyHeadersToClipboard]="false"
  [ensureDomOrder]="true"
  [rowModelType]="rowModelType"
  [copyGroupHeadersToClipboard]="copyGroupHeadersToClipboard"
  [suppressCopyRowsToClipboard]="true"
  [suppressCopySingleCellRanges]="true"
  [multiSortKey]="'ctrl'"
  [sideBar]="sideBar"
  [getRowId]="getRowId"
  [editType]="editType"
  [domLayout]="domLayout"
  [rowBuffer]="100"
  [gridOptions]="$any(gridOptions)"
  [rowDragManaged]="isGridDraggable"
  (gridReady)="gridReady.emit($event)"
  (filterChanged)="filterChanged.emit($event)"
  (sortChanged)="sortChanged.emit($event)"
  (rowClicked)="rowClicked.emit($event)"
  [masterDetail]="hasMasterDetail"
  [detailCellRendererParams]="detailCellRendererParams"
  [keepDetailRows]="keepDetailRows"
  [tooltipMouseTrack]="true"
  [tooltipShowDelay]="300"
  [keepDetailRowsCount]="keepDetailRowsCount"
  [rowHeight]="rowHeight"
  (cellValueChanged)="cellValueChanged.emit($event)"
  (cellClicked)="cellClicked.emit($event)"
  (rowValueChanged)="rowValueChanged.emit($event)"
  (rowDragEnd)="rowDragEnd.emit($event)"
  (rowDragEnter)="rowDragEnter.emit($event)"
  (rowDragMove)="rowDragMove.emit($event)"
  [suppressMoveWhenRowDragging]="true"
  (columnVisible)="columnVisible.emit($event)"
  [stopEditingWhenCellsLoseFocus]="true"
  (rowDoubleClicked)="rowDoubleClicked.emit($event)"
  [processCellForClipboard]="processCellForClipboardExternalFunction || processCellForClipboard"
  (rowSelected)="rowSelected.emit($event)"
  (selectionChanged)="selectionChanged.emit($event)"
  [defaultExcelExportParams]="defaultExcelExportParams"
  (rowGroupOpened)="rowGroupOpened.emit($event)"
  (cellDoubleClicked)="cellDoubleClicked.emit($event)"
  [excelStyles]="excelStyles"
  (cellEditingStarted)="cellEditingStarted.emit($event)"
  (cellEditingStopped)="cellEditingStopped.emit($event)"
/>
